module.exports = __webpack_public_path__ + "img/g-edit.963674f7.svg";